import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { LoadshiftSiteStatsCollection } from './loadshift-site-stats.types';

export function LoadshiftSiteStatsBackend(): Backend<LoadshiftSiteStatsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: () => ({
      endpoint: 'enterprise/loadshift/loadshiftSiteStats.php',
      isGaf: true,
      params: {},
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
